<template>
<div>
    <b-card no-body border-variant="light" v-if="device.status.network.interface.lan.ts">
        <div slot="header">
            <strong>Network Interfaces:</strong> Updated {{relativeTime(device.status.network.interface.lan.ts)}}
            <b-button class="btn btn-primary btn-sm float-right" variant="light" v-if="this.timer===true && device.presence" @click="sendCmd(device.id, 'interface_stats', 2000)">
                <b-overlay :show="busy" rounded spinner-small spinner-variant="primary">
                    <i class="fa fa-refresh"></i>
                </b-overlay>
            </b-button>
        </div>

        <b-card no-body>
            <b-tabs small card justified>
                <b-tab v-for="(int, name, idx) in device.status.network.interface" :key="idx" :title='name.toUpperCase()' :active='activeTab(name)' lazy>
                    <template v-slot:title>
                        {{name.toUpperCase()}}
                        <span v-if="int.data.up">
                            <b-img blank blank-color="#20a8d8" class="mr-2" width="6" height="6"></b-img>
                        </span>
                    </template>
                    <b-row no-gutters>
                        <b-col sm=4>
                            <b-card no-body border-variant="light">
                                <statusdisplay :kkey="'Interface Name'" :vvalue="name"></statusdisplay>
                                <statusdisplay :kkey="'Last Update'" :vvalue="relativeTime(int.ts)"></statusdisplay>
                                <statusdisplay :kkey="'Interface Status'" :vvalue="bool2text(int.data.up)"></statusdisplay>
                                <statusdisplay :kkey="'Device'" :vvalue="int.data.device"></statusdisplay>
                                <div v-if="int.data.up">
                                    <statusdisplay :kkey="'Interface uptime'" :vvalue="fmtSeconds(int.data.uptime)"></statusdisplay>
                                    <statusdisplay :kkey="'Connection Protocol'" :vvalue="int.data.proto.toUpperCase()"></statusdisplay>
                                    <div v-for="(o, n, i) in int.data['ipv4-address']" :key="'ipv4-'+i">
                                        <statusdisplay :kkey="'IPv4 address'" :vvalue="cat(o.address, '/', o.mask)"></statusdisplay>
                                    </div>
                                    <div v-if="int.data['dns-server'].length > 0">
                                        <div v-for="(o, n, i) in int.data['dns-server']">
                                            <statusdisplay :kkey="cat('DNS Server', ' ', n+1)" :vvalue="o"></statusdisplay>
                                        </div>
                                    </div>
                                    <div v-if="int.data.route.length > 0">
                                        <b-table small :fields="routefields" :items="int.data.route" responsive="sm" primary-key="source" caption="Routes" caption-top>
                                        </b-table>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                        <b-col sm=8>
                            <b-card border-variant="light">
                                <div v-if="int.data.up">
                                    <!-- <plottraffic chartId="traffic" class="chart-wrapper" style="height:350px;margin-top:10px;" :interface=name :radiosBtn=radiosBtn></plottraffic> -->
                                    <plotform :interface=name :deviceID="device.id"></plotform>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-tab>
                <!-- Render this if no tabs -->
                <template v-slot:empty>
                    <div class="text-center text-muted">
                        There are no open tabs
                    </div>
                </template>
            </b-tabs>
        </b-card>

    </b-card>

</div>
</template>

<script>
import moment from 'moment';
import StatusDisplay from './StatusDisplay';
import PlotTraffic from '../graphs/PlotTraffic'
import PlotForm from '../graphs/PlotForm'

export default {
    components: {
        'statusdisplay': StatusDisplay,
        'plottraffic': PlotTraffic,
        'plotform': PlotForm,
    },
    props: {
        device: {
            type: Object,
        },
    },

    data() {
        return {
            busy: false,
            timer: false,
            tabs: [],
            tabCounter: 0,
            routefields: [
                { key: 'mask', label: 'Mask', sortable: true },
                { key: 'source', label: 'Source', sortable: true },
                { key: 'target', label: 'Target', sortable: true },
                { key: 'nexthop', label: 'Nexthop', sortable: true },
            ]
        }
    },
    created() {
        this.timer = setInterval(this.enableTimer, 1000);
    },
    methods: {
        activeTab(val) {
            return (val === "lan") ? true : false;
        },
        linkClass(idx) {
            return (idx) ? ['bg-primary', 'text-light'] : ['bg-light', 'text-info'];
        },
        relativeTime(value) {
            let localTime = moment.unix(value).local();
            return (value == null) ? '-' : moment(localTime).fromNow()
        },
        bool2text(value) {
            return (value) ? "Running" : "Not running";
        },
        fmtSeconds(secs) {
            return moment.utc(secs * 1000).format('HH:mm:ss') + " (h:m:s)"
        },
        cat(s1, s2, s3) {
            return s1 + s2 + s3;
        },
        enableTimer() {
            this.timer = true;
        },
        relativeTime(value) {
            let localTime = moment.unix(value).local();
            return (value == null) ? '-' : moment(localTime).fromNow()
        },
        makeToast(variant = null, message = null) {
            this.$bvToast.toast(message, {
                // title: `Config Updated ${variant || 'default'}`,
                title: `Notification:`,
                variant: variant,
                toaster: 'b-toaster-top-center',
                solid: true
            });
        },
        sendCmd(id, op, wait) {
            this.busy = true;
            let uri = `/api/devices/${this.device.id}/op?op=${op}`;
            axios.get(uri).then((response) => {
                if (response.data.success === true) {
                    let msg = 'Request sent.' + ' Wait ' + wait / 1000 + ' seconds.';
                    this.makeToast('info', msg);
                    this.stReturn = setTimeout(() => {
                        this.$emit('childgetData_event');
                        this.busy = false;
                    }, wait);
                } else {
                    this.makeToast('danger', 'Unable to contact device.');
                }
            });
        },
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
}
</script>
